import {
	getSmartPlatform
} from "../wniutil/common.js";

export const loadGptJS = (() => {
	let loaded = false;
	return () => {
		if (loaded) return;
		loaded = true;
		const uri = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
		if (document.querySelector('script[src$="/tag/js/gpt.js"]')) return;

		const gads = document.createElement("script");
		gads.src = uri;
		const node = document.getElementsByTagName("script")[0];
		node.parentNode.insertBefore(gads, node);
	};
})();

export const loadPwtJS = (() => {
	const loaded = {};
	return (smartPlatform) => {
        const targetSmartPlatform = smartPlatform || getSmartPlatform();
		const purl = window.location.href;
		const accountId = "161034";
		const profileId = targetSmartPlatform ? "15524" : "15519";
		let profileVersionId = "";

		// URLからプロファイルバージョンを取得
		if (purl.indexOf("pwtv=") > 0) {
			const regexp = /pwtv=(.*?)(&|$)/g;
			const matches = regexp.exec(purl);
			if (matches && matches.length >= 2 && matches[1].length > 0) {
				profileVersionId = `/${matches[1]}`;
			}
		}

		const cacheKey = `${targetSmartPlatform}-${profileId}${profileVersionId}`;
		if (loaded[cacheKey]) return;

		const url = `//ads.pubmatic.com/AdServer/js/pwt/${accountId}/${profileId}`;
		if (document.querySelector(`script[src$="${url}"]`)) return;

		const wtads = document.createElement("script");
		wtads.async = true;
		wtads.type = "text/javascript";
		wtads.src = `${url}${profileVersionId}/pwt.js`;
		const node = document.getElementsByTagName("script")[0];
		node.parentNode.insertBefore(wtads, node);
		loaded[cacheKey] = true;
	};
})();

export const loadApsTagJS = (() => {
	let loaded = false;
	return () => {
		if (loaded) return;
		loaded = true;
		((a9, a, p, s, t, A, g) => {
			if (a[a9]) return;
			function q(c, r) {
				a[a9]._Q.push([c, r]);
			}
			a[a9] = {
				init: (...args) => {
					q("i", args);
				},
				fetchBids: (...args) => {
					q("f", args);
				},
				setDisplayBids: () => {},
				targetingKeys: () => {
					return [];
				},
				_Q: [],
			};
			const AA = A || p.createElement(s);
			AA.async = !0;
			AA.src = t;
			const gg = g || p.getElementsByTagName(s)[0];
			gg.parentNode.insertBefore(AA, gg);
		})(
			"apstag",
			window,
			document,
			"script",
			"//c.amazon-adsystem.com/aax2/apstag.js",
		);
	};
})();

export const loadAdSenseJS = (() => {
	let loaded = false;
	return () => {
		if (loaded) return;
		loaded = true;
		const ad = document.createElement("script");
		ad.type = "text/javascript";
		ad.async = true;
		ad.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
		const sc = document.getElementsByTagName("script")[0];
		sc.parentNode.insertBefore(ad, sc);
		// init adsbygoogle
		window.adsbygoogle = window.adsbygoogle || [];
		window.adsbygoogle.push({});
	};
})();
